<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
                <v-icon left>person</v-icon>
                <span v-if="isNewCustomer">Opprett kunde</span>
                <span v-else>Rediger kunde</span>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar>
                <v-toolbar-title>
                    <span v-if="isNewCustomer">Opprett kunde</span>
                    <span v-else>Rediger {{ customer.name }}</span>
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text v-if="loading">
                <v-progress-linear indeterminate/>
            </v-card-text>
            <div v-else>
                <v-container grid-list-md class="pa-3">
                    <v-layout row wrap>
                        <v-flex md4>
                            <v-text-field label="Kundenummer" v-model="customer.customer_number"
                                          :error-messages="errors.customer_number" autofocus/>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field label="Navn" v-model="customer.name" class="input-capitalize"
                                          :error-messages="errors.name"/>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex md6>
                            <v-text-field label="Adresse" v-model="customer.address" :error-messages="errors.address"/>
                        </v-flex>
                        <v-flex md2>
                            <v-text-field label="Postnr" v-model="customer.zip_code" :error-messages="errors.zip_code"/>
                        </v-flex>
                        <v-flex md4>
                            <v-text-field label="Sted" v-model="customer.city" :error-messages="errors.city"/>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex md6>
                            <v-select label="Kundetype" v-model="customer.is_company" :items="customerTypeItems"
                                      :error-messages="errors.is_company"/>
                        </v-flex>
                        <v-flex md6 v-if="customer.is_company">
                            <v-text-field label="Org.nr." v-model="customer.org_number"
                                          :error-messages="errors.org_number"/>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex md12>
                            <customer-category-select v-model="customer.category_id" placeholder="Ingen"/>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex md3>
                            <v-text-field label="Telefon" v-model="customer.phone" :error-messages="errors.phone"/>
                        </v-flex>
                        <v-flex md3>
                            <v-checkbox label="SMS" v-model="customer.has_sms" :error-messages="errors.has_sms"/>
                        </v-flex>
                        <v-flex md6>
                            <v-text-field label="Epost" v-model="customer.email" :error-messages="errors.email"/>
                        </v-flex>
                        <v-flex md12>
                            <v-textarea label="Notat / merknad" outlined v-model="customer.note"
                                        :error-messages="errors.note"/>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-card-actions>
                    <v-btn color="red" text @click="dialog = false">
                        <v-icon left>close</v-icon>
                        Lukk
                    </v-btn>
                    <v-spacer/>
                    <v-btn color="green" text @click="save" :loading="loading">
                        <v-icon left>save</v-icon>
                        Lagre
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from 'axios';
    import {capitalize, getCustomerTypeItems} from "../../helpers";
    import CustomerCategorySelect from './CustomerCategorySelect';

    export default {
        components: {
            CustomerCategorySelect
        },
        props: {
            customerId: [Number, null]
        },

        data() {
            return {
                loading: false,
                dialog: false,
                errors: {},
                customer: {
                    is_company: false // Bool must have default.
                },

                zipCodes: {}
            }
        },

        methods: {
            loadData() {
                if (this.customerId) {
                    this.loading = true;
                    this.$http.get(`customers/${this.customerId}`).then(response => {
                        this.customer = response.data.data;
                    }).finally(() => this.loading = false);
                }

                axios.get('/json/postnummer.json').then(response => {
                    this.zipCodes = response.data;
                });
            },
            save() {
                this.loading = true;
                this.errors = {};

                let data = {
                    ...this.customer,
                    name: capitalize(this.customer.name),
                };
                let request;
                if (this.customerId) {
                    request = this.$http.put(`customers/${this.customerId}`, data);
                } else {
                    request = this.$http.post('customers', data);
                }

                request.then(response => {
                    this.customer = response.data.data;
                    this.$emit('save', this.customer);
                    this.dialog = false;
                    this.$root.addMessage('Kunden ble lagret.', 'success');
                }).catch(error => {
                    this.errors = error.response.data.errors || {};
                }).finally(() => {
                    this.loading = false;
                });
            }
        },

        watch: {
            dialog() {
                if (this.dialog) {
                    this.loadData();
                }
            },

            'customer.is_company': function (state) {
                if (!state) this.customer.org_number = '';
            },

            'customer.zip_code': function (zipCode) {
                let city = this.zipCodes[zipCode];
                if (!city) return;

                this.customer.city = city;
            }
        },

        computed: {
            isNewCustomer() {
                return !this.customerId;
            },

            customerTypeItems() {
                return getCustomerTypeItems();
            }
        }
    }
</script>
